import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ControlPanel1 from "./controlPanel1";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import { onboardingServices } from "../../services/onboardingServices";
import AlertComponent from "../alert/alert";
import routes from "../../routes";
import { subRouteMapping } from "../../constant/subRoutes";
import { adminServices } from "../../services/adminServices";

const onboardingTypeOptions1 = [
  { label: "Regular Onboarding", value: "REGULAR_ONBOARDING" },
  { label: "Direct Onboarding", value: "DIRECT_ONBOARDING" },
  {
    label: "Onboarding without Document",
    value: "ONBOARDING_WITHOUT_DOCUMENTS",
  },
  { label: "SAP", value: "SAP" }
];

function ControlPanel() {
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedPageOption, setPageSelectedOption] = useState(null);
  const [selectedModuleOption, setSelectedModuleOption] = useState({value: "VendorOnboarding"});
  const [tableDetails, setTableDetails] = useState({ sections: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [configSubRoute, setConfigSubRoute] = useState([]);
  const [tabArr, setTabArr] = useState([]);
  const [onboardingTypeOptions, setOnboardingTypeOptions] = useState(
    onboardingTypeOptions1
  );
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    setIsLoading(true);
    onboardingServices
      .getAdminStep("")
      .then(function (response) {
        if (response.data.success == true) {
          let arr = [
            ...response?.data?.data,
            // { _id: 3, stepName: "Vendor Registration Form" },
            // { _id: 4, stepName: "Vendor Listing - Existing" },
            // { _id: 5, stepName: "Vendor Listing - New" },
          ];
          setTabArr(arr);
          setSelectedOption(arr[0]);
          setPageSelectedOption(onboardingTypeOptions1[0]);
          getStepById(
            arr[0]?._id,
            `?onboardingType=${onboardingTypeOptions1[0]?.value}`
          );
        } else {
          setTabArr([]);
        }
      })
      .catch(function (error) {
        setTabArr([]);
        // openAlert(true, 'error', `${error?.response?.data?.message}` );
      })
      .finally((param) => {
        setIsLoading(false);
      });

    setConfigSubRoute(subRouteMapping(routes, "CONFIGURATION"));
  }, []);

  const handleSelectChange = (event) => {
    // const selectedKey = parseInt(event.target.value, 10);
    setIsLoading(true);
    const selectedOption = tabArr.find(
      (option) => option._id == event.target.value
    );
    getStepById(
      selectedOption?._id,
      `?onboardingType=${selectedPageOption?.value}`
    );
    setSelectedOption(selectedOption);
  };

  const handlePageSelectChange = (e) => {
    // const selectedKey = parseInt(event.target.value, 10);
    // setIsLoading(true);
    let  {name, value} = e.target;
    const selectedPageOptionInit = onboardingTypeOptions.find(
      (option) => option.value == value
    );
    if (selectedModuleOption?.value == "VendorOnboarding") {      
      getStepById(
        selectedOption?._id,
        `?onboardingType=${selectedPageOptionInit?.value}`
      );     
    } 
    else {
      getFieldConfig(selectedModuleOption?.value, value);
    }    
    setPageSelectedOption(selectedPageOptionInit);
  };

  const handleModuleSelectChange = (e) => {
    // const selectedKey = parseInt(event.target.value, 10);
    // setIsLoading(true);
    let  {name, value} = e.target;
    
    const selectedPageOptionInit = onboardingTypeOptions.find(
      (option) => option.value == value
    );    
    if (value == "VendorOnboarding") {
      setOnboardingTypeOptions(onboardingTypeOptions1);      
    } else {
      getPageByModule(`?moduleName=${value}`);
    }
    // console.log(selectedPageOptionInit);
    setTableDetails({});
    // setTabArr([]);    
    setSelectedModuleOption({value});
  };

  const getStepById = (param, onboardingType) => {
    setIsLoading(true);
    onboardingServices
      .getAdminStepsById(param, onboardingType)
      .then(function (response) {
        if (response.data.success == true) {
          setTableDetails(response.data.data);
        } else {
          setTableDetails({});
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // setSelectedOption(selectedOption);
  };
  

  const getPageByModule = (param) => {
    setIsLoading(true);
    adminServices
      .getPageByModule(param)
      .then(function (response) {
        if (response.data.success == true) {
          // console.log(response);
          setOnboardingTypeOptions(response?.data?.data?.pages);
        } else {
          setOnboardingTypeOptions([]);
        }
        setTableDetails({});
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // setSelectedOption(selectedOption);
  };
  
  const getFieldConfig = (moduleName, pageName) => {
    setIsLoading(true);
    let param = `?moduleName=${moduleName}&page=${pageName}`;
    adminServices
      .getFieldConfig(param)
      .then(function (response) {
        if (response?.data?.success == true) {
          console.log(response);
          // setOnboardingTypeOptions(response?.data?.data?.pages);
          setTableDetails(response?.data?.data);
        } else {          
          setTableDetails({});
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // setSelectedOption(selectedOption);
  };

  const updateStepField = (bodyData, fieldId) => {
    setIsLoading(true);
    
    let promise = "";
    if (selectedModuleOption?.value == "VendorOnboarding") {    
      bodyData.onboardingType = selectedPageOption?.value; 
      promise = onboardingServices.updateStepField(bodyData, tableDetails?._id);    
    } 
    else {   
      promise = adminServices.updateFieldConfig(bodyData, fieldId);  
    } 
    
    promise.then(function (response) {
      if (response.data.success == true) {
        setTableDetails(response.data.data);
      } else {
        setTableDetails({});
      }
    })
    .catch(function (error) {
      openAlert(true, "error", `${error?.response?.data?.message}`);
    })
    .finally((param) => {
      setIsLoading(false);
    });
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  return (
    <div class="login-forms">
      <div class="text-centers">
        <div class="heading_search_outer d sub-route-upper-sec">
          <div>
            <div className="sub-route-sec">
              {configSubRoute.map(
                (ele, i) =>
                  ele.isSubRoute && (
                    <div
                      className={
                        location.pathname.indexOf(ele.path) !== -1
                          ? "sub-route-sec-div sub-route-sec-div-active"
                          : "sub-route-sec-div"
                      }
                    >
                      <Link to={ele.layout + ele.path}>{ele.name}</Link>
                      {/* <p>Existing Vendor</p> */}
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
        <div className="panel_control_admin_react">
          <div className="listing_block_react_control_panel">
            <label className="control_panel_react_listing_onboarding">
              Module
            </label>
            <select
              id="onboardingType"
              class="form-select react_controlpanel_select"
              aria-label="Default select example"
              fdprocessedid="5g569t"
              value={selectedModuleOption?.value}
              onChange={handleModuleSelectChange}
            >
              <option value="VendorOnboarding"> Vendor Onboarding </option>
              <option value="BIDDING"> Bidding & RFQ </option>
              {/* <option value="ContractManagement">Contract Management </option> */}
              <option value="P2P"> P2P lifecycle</option>
              {/* <option value="Finance">Finance </option> */}
            </select>
          </div>
          <div className="listing_block_react_control_panel">
            <label className="control_panel_react_listing_onboarding">
              Page
            </label>
            <select
              id="onboardingType"
              class="form-select react_controlpanel_select"
              aria-label="Default select example"
              fdprocessedid="5g569t"
              value={selectedPageOption?.value}
              onChange={handlePageSelectChange}
            >
              <option value="" >
                Please select
              </option>
              {onboardingTypeOptions.map((option, i) => (
                <option key={i} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {(selectedModuleOption?.value == "VendorOnboarding") && <div className="listing_block_react_control_panel">
            <label className="control_panel_react_listing_onboarding">
              Tabs
            </label>
            <select
              id="onboardingType"
              className="form-select react_controlpanel_select"
              aria-label="Default select example"
              fdprocessedid="5g569t"
              value={selectedOption?._id}
              onChange={handleSelectChange}
            >
              {tabArr?.map((option) => (
                <option key={option?._id} value={option?._id}>
                  {option?.stepName}
                </option>
              ))}
            </select>
          </div>}
          {/* <div className="apply_btn_block">
            <button
              type="button"
              className="clear_btn_status_block_list_panel"
              data-dismiss="modal"
              fdprocessedid="0y9izm"
            >
              Clear
            </button>
            <Button className="btn btn-success">Apply</Button>
          </div> */}
        </div>

            {(tableDetails?.sections?.length > 0) ? <>
              {tableDetails?.sections?.map((ele, i) => (
                <ControlPanel1
                  tableDetails={ele}
                  updateStepField={updateStepField}
                  stepId={selectedOption?._id}
                  selectedPageOption={selectedPageOption}
                  getStepById={getStepById}
                  getFieldConfig={getFieldConfig}
                  selectedModuleOption={selectedModuleOption}
                />
              ))}
            </> : <>
              <div className="text-center">No data found</div>
            </> }
        

        {/* <div className="clear_btn_status_block_react_controlpanel">
          <button
            type="button"
            className="clear_btn_status_block_list"
            data-dismiss="modal"
            fdprocessedid="0y9izm"
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-success save_next_btn"
            fdprocessedid="ao4xc"
          >
            Submit
          </button>
        </div> */}

        {/* {selectedOption.stepName == "Business and Contact Information" && <ControlPanel1 />}
        {selectedOption.stepName == "Financial, Tax and Operational Information" && <Financialtax />}
        {selectedOption.stepName == "Technical, Compliance, and Quality Assurance Documentation" && <Technicalcompliance />}
        {selectedOption.stepName == "Vendor Registration Form" && <Vendorregistrationform />}
        {selectedOption.stepName == "Vendor Listing - Existing" && <Vendorlistingexisting />}
        {selectedOption.stepName == "Vendor Listing - New" && <Newlistingvendor />} */}
      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 99999999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default ControlPanel;
